import { useCallback, useState } from 'react';

export default function useCompromisoPagoForm(createInitialForm) {
  const [formData, setFormData] = useState(() => createInitialForm());
  const [errors, setErrors] = useState({});

  const resetForm = useCallback(
    (...args) => {
      setFormData(createInitialForm(...args));
      setErrors({});
    },
    [createInitialForm]
  );

  const handleChange = useCallback((event) => {
    const { name, value } = event.target;

    setFormData((currentForm) => ({
      ...currentForm,
      [name]: value
    }));

    setErrors((currentErrors) => {
      if (!currentErrors[name]) {
        return currentErrors;
      }

      return {
        ...currentErrors,
        [name]: ''
      };
    });
  }, []);

  return {
    formData,
    setFormData,
    errors,
    setErrors,
    resetForm,
    handleChange
  };
}